import { OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/index';
import './../rxjs-operators';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/timer';
import * as moment from 'moment-timezone';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(route, router, authenticationService) {
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.showSpinner = false;
        this.redirectFromLogout = false;
        this.routerSubscriber = null;
        this.resetPassword = false;
        this.resetPasswordLink = null;
        this.emailId = null;
        this.setdate = moment('2017-07-10 21:00:00', 'YYYY-MM-DD HH:mm:ss'); // today date
    }
    // Once the LogIn Component loads, check if the user passed any parameters via the 'accessPage' browser params.
    // Those params indicate the page the user wants to nrowse to, immediately after the login page, without authenticating
    // once again.
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routerSubscriber = this.route.params.subscribe(function (params) {
            console.log('Logging inside the router subscriber startss');
            console.log(params);
            var noDelayParam = params['noDelay'];
            console.log(noDelayParam);
            if (noDelayParam != null && noDelayParam == 'true') {
                _this.redirectFromLogout = true;
            }
            if (noDelayParam == 'reset') {
                _this.resetPassword = true;
            }
            _this.resetPasswordLink = _this.route.snapshot.queryParams["resetPasswordLink"];
            _this.emailId = _this.route.snapshot.queryParams["emailId"];
            console.log(_this.emailId, _this.resetPasswordLink);
            if (_this.resetPasswordLink != null && _this.emailId != null) {
                _this.resetPassword = true;
            }
            console.log(_this.redirectFromLogout);
            console.log('Logging inside the router subscriber ends');
        });
        var accessPage = localStorage.getItem("accessPage");
        console.log("accessPage ==>" + accessPage);
        if (accessPage) {
            console.log("accessPage is available==>" + accessPage);
            if (accessPage != null && accessPage !== "null" && accessPage.length > 0) {
                console.log("accessPage exsts, will start routimg now" + accessPage.length);
                this.showSpinner = true;
                // if the URL is a public URL, but the user has logged in, then redirect to logged in URL.
                if (accessPage.includes("public/") && this.authenticationService.isAuthenticated()) {
                    accessPage = accessPage.replace("public/", "/dashboard/");
                }
                // Extract the CourseId
                if (accessPage.includes("?")) {
                    var queryParam = accessPage.split("?")[1];
                    console.log("queryParam ===>" + queryParam);
                    if (queryParam.includes("=")) {
                        var parameter = queryParam.split("=")[0];
                        console.log("parameter ===>" + parameter);
                        var parameterValue = queryParam.split("=")[1];
                        console.log("parameterValue ===>" + parameterValue);
                        var navigationExtras = {
                            queryParams: { parameter: parameterValue },
                            fragment: 'anchor'
                        };
                        console.log("navigationExtras ===>" + navigationExtras);
                        this.router.navigateByUrl(accessPage, navigationExtras);
                    }
                }
                else {
                    console.log("Plain and simple routing withut params");
                    this.router.navigateByUrl(accessPage);
                }
                console.log("accessPage exsts, routng completed");
                console.log("Routing done, now removing the accessPage localstorage item");
                // Routing done. This is going to be a one time activity. Remove the token from LocalStorage once done.
                localStorage.removeItem('accessPage');
            }
            else {
                if (!this.redirectFromLogout) {
                    console.log("accessPage is not available");
                    this.showSpinner = true;
                    this.timer = Observable.timer(500); // 5000 millisecond means 5 seconds
                    this.subscription = this.timer.subscribe(function () {
                        _this.showSpinner = false;
                        // set showloader to false to hide loading div from view after 5 seconds
                    });
                }
            }
        }
        else {
            console.log("accessPage is not available");
            if (!this.redirectFromLogout) {
                this.showSpinner = true;
                this.timer = Observable.timer(500); // 5000 millisecond means 5 seconds
                this.subscription = this.timer.subscribe(function () {
                    _this.showSpinner = false;
                    // set showloader to false to hide loading div from view after 5 seconds
                });
            }
        }
        console.log("Init ends");
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        this.routerSubscriber.unsubscribe();
    };
    LoginComponent.prototype.closeResetPopup = function () {
        this.resetPassword = false;
        this.router.navigate(['/login']);
    };
    return LoginComponent;
}());
export { LoginComponent };
//# sourceMappingURL=login.component.js.map